import { Account } from "./Account"

export interface DailyReport {
    date: Date
    cost: number
    leads: number
    clicks: number
}

interface LeadLog {
    dateList: string
    leadsList: string
    costList: string
    clickList: string
}

export interface ReportEntry extends LeadLog {
    reach: number
    impressions: number
    clicks: number
    nLeads: number
    nDays: number
    days: number
    expectedLeads: number
    leads7Days: number
    remaingLeads: number
    leadCost: number
    todayLeads: number
    todayCost: number
    goal: number
    goalSpread: number
    customGoal: number
    score: number
    dayGoal: number
    dayBudget: number
    goalRatio: number
    leadProjection: number
    budget: number
    expectedBudged: number
    overrun: number
    totalCost: number
    suggestedBudget: number
    trend: string
    dailyReports: DailyReport[]
    missingDays: number
    info?: {
        filteredCampaigns?: {cost: number, clicks: number, leads: number, impressions: number},
        googleId?: string,
        googleCustomerId?: string
        googleBudget?: number
    }
}

export type DayInfo = {
    leads: number,
    cost: number
}

export interface FullReportEntry extends Account, ReportEntry {
    past?: ReportEntry
    slDate?:string
    changeStatusToday?:boolean
    lastDate: Date
    pastMonthSameDay?: DayInfo
    pastMonthYesterDayInfo?: DayInfo
    yesterDayInfo?: DayInfo
    
}


export function percentage(account:ReportEntry, detailInfoMode: string){
    if(detailInfoMode == "cost"){
        if(account.budget == 0) return 0;
        return Math.min(Math.round(account.totalCost / account.budget * 100), 100) + "%";        
    }

    if(account.goal == 0) return 0;
    return Math.min(Math.round(account.nLeads / account.goal * 100), 100) + "%";
}

export function cpl(account:ReportEntry){
    if(!account) return 0;
    if(account.nLeads == 0) return 0;
    return account.totalCost / account.nLeads
}

export function gap(account:ReportEntry){
    if(!account) return 0;
    return account.nLeads - account.expectedLeads
}

export function monthGap(account:ReportEntry){
    if(!account) return 0;
    return account.nLeads - account.goal
}

export function cpm(account:ReportEntry){
    if(!account) return 0;
    return account.totalCost / account.impressions * 1000
}

export function cpi(account:ReportEntry){
    if(!account) return 0;
    return account.totalCost / account.impressions
}

export function frequency(account:ReportEntry){
    return account.reach == 0 ? 0 : account.impressions / account.reach
}

export function missingInfoDayCount(account:FullReportEntry):number{
    const today = new Date();
    if(!account.lastDate) return null;
    const timeDifference = today.getTime() - account.lastDate.getTime();
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return daysDifference == -1 ? null : daysDifference;
}